import { User } from "../../types/data";

function UserInfo({avatar, title}: User) {
  return (
    <div className="flex items-center gap-1">
      <span className="rounded-full w-6 h-6 bg-[#012169] flex-shrink-0"></span>
      <span>{title}</span>
    </div>
  )
}

export default UserInfo;
